@if (isLoadingApp) {
  <app-loading-logo/>
} @else {
  <main class="main-container" techScrollbars>
    <router-outlet></router-outlet>

    @if (!isProduction) {
      <footer class="app-version">
        v{{ version }}
      </footer>
    }
  </main>
}
